import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HighlightedMessageComponent } from './highlighted-message.component';
import { HighlightedMessageService } from './highlighted-message.service';
import { MatIconModule } from '@angular/material/icon';

/**
 * This is the module used for the Highlighted message
 * @exports HighlightedMessageModule
 * @class HighlightedMessageModule
 */
@NgModule({
  declarations: [HighlightedMessageComponent],
  imports: [CommonModule, MatIconModule],
  exports: [HighlightedMessageComponent],
  providers: [HighlightedMessageService],
})
export class HighlightedMessageModule {}
